import { Alert, Box } from "@prismicio/editor-ui"
import { useEffect, useState } from "react"

import { useRole } from "../app/services/user"
import { useDocument } from "./DocumentProvider"
import { useGoToDocumentList } from "./documentRouting"

export function ContributorAlert() {
  const { locale } = useDocument()
  const { isContributor } = useRole(locale)

  const [open, setOpen] = useState(isContributor)

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden"

    return () => {
      // Resets the inline style to let the stylesheet take over.
      document.body.style.overflow = ""
    }
  }, [open])

  const goToDocumentList = useGoToDocumentList()

  if (!open) return null

  return (
    <div
      style={{
        background: fullHeightLinearGradient,
        position: "fixed",
        height: "100%",
        width: "100%",
        top: 0,
        left: 0,
      }}
    >
      <Box justifyContent="center" flexGrow={1}>
        <Box
          position="absolute"
          top={32}
          flexDirection="row"
          justifyContent="center"
          width={645}
        >
          <Alert
            icon="alert"
            title="You don’t have the rights to edit this document."
            subtitle="If you want to edit or translate this document then you will need to ask an admin to grant you the necessary status."
            rightButton={{
              type: "close",
              onClick: () => setOpen(false),
            }}
            footerButtons={{
              dismiss: {
                text: "Cancel",
                onClick: goToDocumentList,
              },
              action: {
                text: "View as read only",
                onClick: () => setOpen(false),
              },
            }}
          />
        </Box>
      </Box>
    </div>
  )
}

const fullHeightLinearGradient =
  "linear-gradient(0deg, rgba(249, 248, 249, 0.60) 0%, #F9F8F9 74.3%)"
